/* Pickld variant art (19 Oct 2026). The picture follows the picker.

   The homepage chart rows (sections/pickld-chart-hero.liquid) and the New paddles
   cards (sections/pickld-new-paddles.liquid) draw a picture of the product beside
   the shared buy row's picker (a select or colour swatches). The buy row's own
   script (pickld-buy-row.js) updates the price, the words on the button and a
   thumbnail marked [data-pickld-buy-img], but that thumbnail is the picker's 96px
   photo: it would swap a cut-out for a small photo with the wrong shape. So these
   two sections do not mark one, and this script does the swap with art the section
   worked out in Liquid. Full doc: docs/components/chart-hero.md, "The picture
   follows the picker", and docs/components/new-paddles.md.

   The contract, all of it:
     [data-pickld-buy-scope][data-pickld-art]   the card or row. data-pickld-art is
        "id|kind|url" entries separated by spaces, one per available variant. id is
        the variant id, kind c is a cut-out, p a photo to contain, f a photo to
        fill (a square-ish one, New paddles only), url the image at the size the
        section draws it.
     data-pickld-art-title    the product's title, for the alt text.
   A scope without data-pickld-art is left alone (every other buy row on the site).

   On a change of the picker (a select's change, a swatch's click):
     * the picture swaps to the chosen variant's art, and swaps back to the
       original when that variant has none. Chart rows: the thumbnail span takes
       or loses pickld-chh__thumb--art (the tilted cut-out look). New paddles: the
       image takes pickld-np__img--cut, --photo or --fill. No. 1 on its artwork
       stage (.pickld-chh__art) takes only a cut-out: a photo there would be a
       tilted rectangle with a shadow.
     * the card takes the pre-order state of the chosen variant the way the
       product page does: is-pre or is-buy on the chart's li, --preorder or --buy
       on New paddles' button wrapper (the button's own words already follow the
       choice, in pickld-buy-row.js, from data-preorder). No. 1's state line reads
       "Pre-order" or "In stock" when the choice differs from what it printed.
   Nothing here adds to the cart, and nothing else on the page is touched.
*/
(function () {
  if (window.pickldVariantArtBound) return;
  window.pickldVariantArtBound = true;

  var NP_CLASS = { c: 'cut', p: 'photo', f: 'fill' };

  function entries(scope) {
    if (scope._pkArt) return scope._pkArt;
    var map = {};
    (scope.getAttribute('data-pickld-art') || '').split(' ').forEach(function (e) {
      var p = e.split('|');
      if (p.length >= 3) map[p[0]] = { kind: p[1], url: p.slice(2).join('|') };
    });
    scope._pkArt = map;
    return map;
  }

  function target(scope) {
    return scope.querySelector('.pickld-chh__art, .pickld-chh__stage-img, .pickld-chh__thumb img, .pickld-np__media img');
  }

  // What the section printed, kept the first time the picture changes so a variant with no art of its own can restore it.
  function remember(img) {
    if (img._pkOrig) return;
    var th = img.closest('.pickld-chh__thumb');
    img._pkOrig = {
      src: img.getAttribute('src'),
      srcset: img.getAttribute('srcset'),
      sizes: img.getAttribute('sizes'),
      alt: img.getAttribute('alt'),
      width: img.getAttribute('width'),
      height: img.getAttribute('height'),
      cls: img.className,
      thumbArt: th ? th.classList.contains('pickld-chh__thumb--art') : null
    };
  }

  function setAttr(img, name, value) {
    if (value === null || value === undefined) img.removeAttribute(name);
    else img.setAttribute(name, value);
  }

  function restore(img) {
    var o = img._pkOrig;
    if (!o) return;
    setAttr(img, 'src', o.src);
    setAttr(img, 'srcset', o.srcset);
    setAttr(img, 'sizes', o.sizes);
    setAttr(img, 'alt', o.alt);
    setAttr(img, 'width', o.width);
    setAttr(img, 'height', o.height);
    img.className = o.cls;
    var th = img.closest('.pickld-chh__thumb');
    if (th && o.thumbArt !== null) th.classList.toggle('pickld-chh__thumb--art', o.thumbArt);
  }

  function paint(scope, img, entry, label) {
    remember(img);
    if (!entry) { restore(img); return; }
    // No. 1 on its artwork stage only ever shows a cut-out.
    if (img.classList.contains('pickld-chh__art') && entry.kind !== 'c') return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    // The old width and height describe the old picture; the new one brings its own.
    img.removeAttribute('width');
    img.removeAttribute('height');
    img.setAttribute('src', entry.url);
    var title = scope.getAttribute('data-pickld-art-title');
    if (title) img.setAttribute('alt', label ? title + ', ' + label : title);
    var th = img.closest('.pickld-chh__thumb');
    if (th) th.classList.toggle('pickld-chh__thumb--art', entry.kind === 'c');
    if (img.classList.contains('pickld-np__img')) {
      Object.keys(NP_CLASS).forEach(function (k) {
        img.classList.toggle('pickld-np__img--' + NP_CLASS[k], k === entry.kind);
      });
    }
  }

  function preorder(scope, pre) {
    if (scope._pkInitPre === undefined) scope._pkInitPre = scope.classList.contains('is-pre');
    if (scope.classList.contains('is-pre') || scope.classList.contains('is-buy')) {
      scope.classList.toggle('is-pre', pre);
      scope.classList.toggle('is-buy', !pre);
    }
    var act = scope.querySelector('.pickld-np__act');
    if (act) {
      act.classList.toggle('pickld-np__act--preorder', pre);
      act.classList.toggle('pickld-np__act--buy', !pre);
    }
    var state = scope.querySelector('.pickld-chh__one-state');
    if (state) {
      if (state._pkText === undefined) state._pkText = state.textContent;
      state.textContent = pre === scope._pkInitPre ? state._pkText : (pre ? 'Pre-order' : 'In stock');
    }
  }

  // The colour or option's name for the alt text: a select option reads "Hybrid", or "Hybrid", a middle dot and the price
  // when the product's prices differ (the buy row's choice); a swatch carries its value.
  function nameOf(el) {
    return (el.tagName === 'OPTION' ? el.textContent.split('\u00b7')[0] : el.dataset.value || '').trim();
  }

  // el is the chosen swatch button or select option.
  function choose(el) {
    var row = el.closest('[data-pickld-buy]');
    var scope = row && row.closest('[data-pickld-buy-scope]');
    if (!scope || !scope.hasAttribute('data-pickld-art')) return;
    var img = target(scope);
    if (img) paint(scope, img, entries(scope)[el.dataset.variantId], nameOf(el));
    preorder(scope, !!el.dataset.preorder);
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.pickld-buy__swatch');
    if (!swatch || swatch.classList.contains('is-unavailable')) return;
    choose(swatch);
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.pickld-buy__select');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (opt) choose(opt);
  });
})();
